import { render, staticRenderFns } from "./btnLayer.vue?vue&type=template&id=16a33015&scoped=true"
import script from "./btnLayer.vue?vue&type=script&lang=js"
export * from "./btnLayer.vue?vue&type=script&lang=js"
import style0 from "./btnLayer.vue?vue&type=style&index=0&id=16a33015&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a33015",
  null
  
)

export default component.exports